import { gsap } from 'gsap';

export function fadeIn(element, duration = 1, onComplete = null) {
    gsap.to(element, {
        duration,
        opacity: 1,
        onComplete
    });
}

export function fadeOut(element, duration = 1, onComplete = null) {
    gsap.to(element, {
        duration,
        opacity: 0,
        onComplete
    });
}

export function slideDown(element, duration = 1, onComplete = null) {
    // Ensure the element is visible but its height is 0
    gsap.set(element, { display: 'block', height: 'auto' });
    const height = element.offsetHeight; // Get the full height of the element

    gsap.fromTo(
        element,
        { height: 0 },
        {
            duration,
            height,
            ease: 'power2.inOut',
            onComplete
        }
    );
}

export function slideUp(element, duration = 1, onComplete = null) {
    const height = element.offsetHeight; // Get the current height of the element

    gsap.fromTo(
        element,
        { height },
        {
            duration,
            height: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                // Hide the element after the animation is complete
                gsap.set(element, {display: 'none'});
                if (onComplete) onComplete();
            }
        }
    );
}